export enum TrustInventoryApprovalPrivilegeEnum {
  NONE = '0',
  FIRST_APPROVER = '1',
  FINAL_APPROVER = '2',
}
export const TrustInventoryApprovalPrivilege = [
  { label: '権限なし', value: TrustInventoryApprovalPrivilegeEnum.NONE },
  { label: '第１承認者', value: TrustInventoryApprovalPrivilegeEnum.FIRST_APPROVER },
  { label: '最終承認者', value: TrustInventoryApprovalPrivilegeEnum.FINAL_APPROVER },
];
